export default __webpack_public_path__ + "static/judith-adao-peppercloud-customer-63260e1ea0e195b4b0f6e45c4cd67553.png";